export enum TypeLocalNameEnum {
	CIDADE = 'CIDADE',
	ZONA = 'ZONA',
	COORDENADAS = 'COORDENADAS',
}

export type GetExamsLocalitiesParams = {
	stateCode: string;
	signal?: AbortSignal;
};

export type ExamLocalities = {
	nmLocal: string;
	nmTipoLocal: TypeLocalNameEnum;
	nmBairro: string;
	nuLatitudade: string;
	nuLongitude: string;
};

export type GetExamsLocalitiesModel = {localidades: ExamLocalities[]};

export interface GetExamsLocalities {
	get: (params: GetExamsLocalitiesParams) => Promise<GetExamsLocalitiesModel>;
}
